//This is for listing all players in the entire system

import React, { useEffect, useState, useRef } from 'react'
import './AdminLeagueList.css'
import AdminNavigation from './AdminNavigation'
import { NavLink } from 'react-router-dom'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'

const AdminAllPlayersInSystemList = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedAllPlayers, setLoadedAllPlayers] = useState()
	const [searchTerm, setSearchTerm] = useState('')

	const playerRefs = useRef({})

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/getAllPlayers',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedAllPlayers(responseData.allPlayers)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])

	const errorHandler = () => {
		setError(null)
	}

	//Once we have all loaded players, let's sort them by lastName/firstName
	if (loadedAllPlayers) {
		loadedAllPlayers.sort(function (a, b) {
			return (
				a.lastName.localeCompare(b.lastName) ||
				a.firstName.localeCompare(b.firstName)
			)
		})
	}

	const handleSearchChange = (e) => {
		const value = e.target.value
		setSearchTerm(value)

		if (!value.trim() || !loadedAllPlayers) return

		const searchValue = value.trim().toLowerCase()

		const foundPlayer = loadedAllPlayers.find((player) =>
			(player.lastName || '').toLowerCase().startsWith(searchValue),
		)

		if (foundPlayer && playerRefs.current[foundPlayer._id]) {
			playerRefs.current[foundPlayer._id].scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			})
		}
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && loadedAllPlayers && (
				<div className='AdminLeagues'>
					<AdminNavigation />
					<h1>All Players in the system:</h1>
					<div className='row'>
						<NavLink
							to={`/admin/newPlayer`}
							exact
							className='centeredButton'
							style={{ display: 'block', width: 'auto', fontWeight: '700' }}
						>
							Click here to add new players.
						</NavLink>
					</div>
					<div className='row' style={{ margin: '1rem 0' }}>
						<input
							type='text'
							className='searchInput'
							placeholder='Start typing a last name...'
							value={searchTerm}
							onChange={handleSearchChange}
							style={{
								maxWidth: window.innerWidth <= 440 ? '200px' : '400px',
								margin: '0 auto',
								display: 'block',
							}}
						/>
					</div>
					<table id='allPlayers'>
						<thead>
							<tr>
								<th>Player</th>
								<th></th>
								{/* <th>USA Ball Hockey Number</th> */}
								<th></th>
							</tr>
						</thead>
						<tbody>
							{loadedAllPlayers.map((player, key) => {
								//const array = player.split(' ')
								let lastName = player.lastName
								let firstName = player.firstName
								let middleInitial = player.middleInitial
								//let usabh = player.usabh
								if (!middleInitial) {
									middleInitial = ' '
								}
								return (
									<tr
										key={key}
										ref={(el) => {
											if (el) {
												playerRefs.current[player._id] = el
											}
										}}
									>
										<td>
											{firstName}
											{middleInitial}
											{lastName}
										</td>

										<td>
											<NavLink
												className='navlinks'
												to={`/admin/${player._id}/playerPhotoAllPlayers`}
												exact
											>
												Add Photo
											</NavLink>
										</td>

										<td>
											<NavLink
												className='navlinks'
												to={`/admin/updatePlayer/${player._id}`}
												exact
											>
												Edit
											</NavLink>
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			)}
		</React.Fragment>
	)
}

export default AdminAllPlayersInSystemList
